import { useAction } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, LinkIcon, PlusIcon } from '@blade/ui-kit'
import { openInviteReferralDialogAction } from '@root/features/referral/atoms'

import { ReferralCard } from './referral-card-common'

type Props = {}

export const ReferralCardInvite: React.FC<Props> = () => {
  const { t } = useTranslation()

  const openInviteReferralDialog = useAction(openInviteReferralDialogAction)

  return (
    <ReferralCard>
      <ReferralCard.Header>
        <Icon icon={LinkIcon} />
        <ReferralCard.Title>{t('referral.invite_referral')}</ReferralCard.Title>
        <Button
          radius="full"
          size="h24"
          variant="solid"
          color="primary"
          iconLeft={<PlusIcon />}
          onClick={openInviteReferralDialog}
        />
      </ReferralCard.Header>
      <ReferralCard.Content>
        {t('referral.invite-referral-description')}
      </ReferralCard.Content>
    </ReferralCard>
  )
}

const Icon = styled(ReferralCard.Icon)`
  color: var(--amber-9);
`
